/**
 * MCP Pairing Approval Store
 *
 * Manages the state of CLI pairing approval requests.
 */

import { create } from 'zustand';
import type { McpPairingApprovalRequest } from '../../../types/mcpPairing';

type PairingApprovalState = {
  pendingRequest: McpPairingApprovalRequest | null;
  setPendingRequest: (request: McpPairingApprovalRequest | null) => void;
  approveRequest: (requestId: string) => void;
  denyRequest: (requestId: string) => void;
};

export const usePairingApprovalStore = create<PairingApprovalState>((set, get) => ({
  pendingRequest: null,

  setPendingRequest: (request) => {
    set({ pendingRequest: request });
  },

  approveRequest: (requestId) => {
    const { pendingRequest } = get();
    if (pendingRequest && pendingRequest.requestId === requestId) {
      window.electronAPI?.mcpUiControl?.sendPairingApprovalResponse(requestId, true);
      set({ pendingRequest: null });
    }
  },

  denyRequest: (requestId) => {
    const { pendingRequest } = get();
    if (pendingRequest && pendingRequest.requestId === requestId) {
      window.electronAPI?.mcpUiControl?.sendPairingApprovalResponse(requestId, false);
      set({ pendingRequest: null });
    }
  },
}));
